import GradientBlock from 'components/GradientBlock';
import { craftingTabs } from 'consts/tabs';
import { Outlet } from 'react-router-dom';
import 'assets/css/craft.css'
import MainTabs from 'components/main-components/MainTabs';
import PageBlockLogin from 'components/page-components/PageBlockLogin';
import useProfile from 'hooks/useProfile';
import Cookies from 'js-cookie';


const CraftingRoute = () => {
  const { isLogged } = useProfile();
  const token = Cookies.get('token');
  return (
    <>
      <GradientBlock additionalClassName='gradient-block--blue'>
        <MainTabs tabs={craftingTabs} />
      </GradientBlock>
      {!token && !isLogged ? <PageBlockLogin /> : <Outlet />}
    </>
  )
}

export default CraftingRoute;
